import React, { useState } from 'react';
import './OnboardingSurvey.css';

const PROFICIENCY_LEVELS = [
  { value: 'Beginner',     label: 'Beginner',     desc: "I'm new to AI tools and still finding my way around." },
  { value: 'Intermediate', label: 'Intermediate', desc: 'I use AI tools sometimes and understand the basics.' },
  { value: 'Advanced',     label: 'Advanced',     desc: 'I use AI tools regularly and confidently in my work.' },
  { value: 'Expert',       label: 'Expert',       desc: 'I have deep expertise and often help others with AI.' },
];

export default function OnboardingSurvey({ user, onDone, onSkip }) {
  const [learningGoals, setLearningGoals] = useState('');
  const [aiProficiency, setAiProficiency] = useState('');
  const [loading,       setLoading]       = useState(false);
  const [error,         setError]         = useState('');

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      const res  = await fetch('/api/learner/onboarding', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ userId: user.id, learningGoals, aiProficiency }),
      });
      const json = await res.json();
      if (!json.success) { setError(json.error || 'Something went wrong.'); setLoading(false); return; }
      onDone(json.data);
    } catch {
      setError('Network error. Please try again.');
      setLoading(false);
    }
  };

  return (
    <div className="onboarding-screen">
            <div className="onboarding-card">
        <h1 className="onboarding-title">Welcome to Okiru Learn, {user.name?.split(' ')[0]}</h1>
        <p className="onboarding-sub">Before you dive in, help us tailor your experience. This takes less than a minute.</p>

        <form className="onboarding-form" onSubmit={submit}>
          <label htmlFor="onboarding-goals">
            What are you hoping to achieve, learn, or get out of Okiru Learn?
            <textarea
              id="onboarding-goals"
              name="learningGoals"
              value={learningGoals}
              onChange={e => setLearningGoals(e.target.value)}
              placeholder="e.g. I want to get comfortable using AI tools day-to-day and understand how they apply to my role…"
              rows={4}
            />
          </label>

          <fieldset className="onboarding-fieldset" aria-describedby={error ? 'onboarding-error' : undefined}>
          <legend className="onboarding-proficiency-label">How would you describe your current AI proficiency? (required)</legend>
          <div className="onboarding-proficiency-grid">
            {PROFICIENCY_LEVELS.map(level => (
              <label
                key={level.value}
                className={`onboarding-proficiency-option${aiProficiency === level.value ? ' onboarding-proficiency-option--selected' : ''}`}
              >
                <input
                  type="radio"
                  name="aiProficiency"
                  required
                  value={level.value}
                  checked={aiProficiency === level.value}
                  onChange={() => setAiProficiency(level.value)}
                />
                <span className="onboarding-proficiency-title">{level.label}</span>
                <span className="onboarding-proficiency-desc">{level.desc}</span>
              </label>
            ))}
          </div>
          </fieldset>

          {error && <p className="onboarding-error" id="onboarding-error" role="alert">{error}</p>}

          <div className="onboarding-actions">
            <button type="button" className="link-btn onboarding-skip" onClick={onSkip}>Skip for now</button>
            <button className="btn btn-primary" type="submit" disabled={loading || !aiProficiency}>
              {loading ? 'Saving…' : 'Submit'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
